import { useEffect, useState } from 'react';
import { getPotentialReason } from './api';
import _ from 'lodash';

interface PotentialReasonProps {
  potentialStatus: string;
}

const PotentialReason = (props: PotentialReasonProps) => {
  const [data, setData] = useState({});
  const { potentialStatus } = props;
  useEffect(() => {
    getPotentialReason()
      .then((res: { code: number, data: any[] }) => {
        if (res.code === 0) {
          const _data = _.reduce(_.values(res.data), (result, value) => {
            return Object.assign({}, result, value);
          }, {});
          setData(_data);
        }
      });
  }, []);
  return <span>{data[potentialStatus] || '-'}</span>;
};

export default PotentialReason;
